import { render, staticRenderFns } from "./CreateTraining.vue?vue&type=template&id=47fb9e3a&scoped=true&"
import script from "./CreateTraining.vue?vue&type=script&lang=js&"
export * from "./CreateTraining.vue?vue&type=script&lang=js&"
import style0 from "./CreateTraining.vue?vue&type=style&index=0&id=47fb9e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb9e3a",
  null
  
)

export default component.exports